import styled from 'styled-components'

import FontAwesome from 'components/FontAwesome'

export const FormContainer = styled.form`
   margin-bottom: 0;
   width: 100%;
   background: ${({ theme, $hasButtonText }) => 
      theme.darkMode && $hasButtonText ? theme.colors.accent : theme.colors.inputBg
   };

   ${({ $hasButtonText, theme }) => $hasButtonText ? `
      .input-wrapper {
         padding: 10px;
         border: solid 1px ${theme.colors.inputBorder};
         border-radius: 4px;
         display: flex;
         align-items: center;
         margin-bottom: 16px;
         background: ${theme.colors.inputBg};

         &:hover {
            border: solid 1px ${theme.colors.inputBorder};
         }
      }
   ` : `
      padding: 10px;
      border: solid 1px ${theme.colors.inputBorder};
      border-radius: 4px;
      display: flex;
      align-items: center;

      &:hover {
         border: solid 1px ${theme.colors.inputBorder};
      }
   `}

   .icon {
      border-radius: 2px;
   }

   ${({ $isFocused, theme, $hasButtonText }) =>
      $isFocused &&
      ($hasButtonText
         ? `
            .input-wrapper {
               border: solid 0.5px ${theme.colors.inputFocusedBorder} !important;
            }
         `
         : `
            border: solid 0.5px ${theme.colors.inputFocusedBorder} !important;
         `
      )};

   ${({ $isFilled, $isFocused, theme, $hasButtonText }) =>
      $isFilled &&
      !$isFocused &&
      ($hasButtonText
         ? `
            .input-wrapper {
               border: solid 0.5px transparent;
            }
         `
         : `
            border: solid 0.5px transparent;
         `
      )};
`

export const Input = styled.input`
   border: none;
   background: none;
   margin-left: 8px;
   outline: none;
   width: 100%;
   height: 100%;
   color: ${({ theme }) => theme.colors.inputColor};
   font-size: 14px;
   line-height: 25px;

   &::placeholder {
      color: ${({ theme }) => theme.colors.inputPlaceholderColor};
   }
`

export const StyledIcon = styled(FontAwesome).attrs(({ theme }) => ({
   icon: 'emailOutline',
}))`
   display: block;
   color: inherit;
   color: ${({ theme }) => theme.colors.accent};
   left: 12px;
   top: 50%;
   font-size: 13px;
`

export const SubmitButton = styled.button`
   padding: 0;
   background-color: transparent;
   border: none;
   cursor: pointer;
   font-size: 13px;

   svg {
      display: block;
   }
`

const StyledSpan = styled.span`
   font-size: 12px;
   line-height: 1.2;
   display: inline-block;
   margin-top: 16px;
`

export const StyledErrorMsg = styled(StyledSpan)`
   color: ${({ theme }) => theme.colors.error};
`

export const StyledSuccessMsg = styled(StyledSpan)`
   color: ${({ theme }) => theme.colors.hotCinnamon};
`
